import React, { useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import styles from "../Settings.module.scss";
import ApplicationsList from "./ApplicationsList";
import EditApplication from "./EditApplication";
import { useDispatch } from "react-redux";
import { addnewApplication, getApplications } from "actions/application.action";

const Applications = (props) => {
  const [isAddFormOpen, setIsAddFormOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch();

  const handleSubmit = async (data) => {
    try {
      setIsSubmitting(true);
      await dispatch(
        addnewApplication({
          active: data.active ?? true,
          ...data,
        })
      );
      await dispatch(getApplications());
      setIsAddFormOpen(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-lg-10 col-md-8"></div>
        <Button
          className={`common-btn col-lg-1 col-md-4 p-2 mt-5 ${styles.button}`}
          onClick={() => {
            setIsAddFormOpen(true);
          }}
        >
          Add <br />
          Application
        </Button>
      </div>
      <div className="row mx-auto mt-3 col-12 col-xl-9 col-xxl-6">
        <ApplicationsList />
      </div>

      {isAddFormOpen && (
        <EditApplication
          cancelEdit={() => setIsAddFormOpen(false)}
          onSubmit={handleSubmit}
          type="addNew"
          isSubmitting={isSubmitting}
        />
      )}
    </React.Fragment>
  );
};

export default Applications;
